export const ADDTOCART = 'cart/addToCart'
export const QTYINCREMENT = 'cart/qtyIncrement'
export const QTYDECREMENT = 'cart/qtyDecrement'
export const DELETE = 'cart/delete'